import { get } from 'lodash';
export const tripMeta = (lodgeMapping, segments) => {
  // @Todo: restore memoize
  if (!segments) segments = [];
  return segments.reduce(
    (meta, itinerary) => {
      if (
        itinerary.type === 'road' ||
        itinerary.type === 'point' ||
        itinerary.type === 'regional' ||
        itinerary.type === 'international' ||
        itinerary.type === 'point' ||
        itinerary.type === 'flight' ||
        itinerary.type === 'scheduled' ||
        itinerary.type === 'chartered' ||
        itinerary.type === 'entry' ||
        itinerary.type === 'exit'
      )
        return meta;
      if (itinerary.location && !meta.locations.includes(itinerary.location)) {
        meta.locations.push(itinerary.location);
      }
      if (itinerary.type === 'stay') {
        if (itinerary.country) {
          if (!meta.countries.includes(itinerary.country)) {
            meta.countries.push({ label: itinerary.country, countryCode: 'ZZ' });
          }
          if (itinerary.regionName) {
            meta.regions.push(itinerary.regionName);
          }
        } else {
          if (itinerary.supplierCode) {
            const lodge = get(lodgeMapping, `lodgeList.${itinerary.supplierCode}`);
            if (lodge) {
              if (!meta.countries.includes(lodge.country)) {
                meta.countries.push(lodge.country);
              }
              const { regionCode } = lodge;
              const region = lodgeMapping.regionList[regionCode];
              if (region) {
                meta.regions.push(region.region);
              }
            }
          }
        }
      }
      return meta;
    },
    { locations: [], countries: [], regions: [] },
  );
};
